module.exports = __webpack_public_path__ + "img/cancel.45ec8f96.svg";